/* 📦 LIBS */
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { ImageProfile, SideBarItem, SideBarSubItem, SideBarLogout} from "./components";

/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { ChangeTextVisibility } from "../../Redux/Actions";

/* 📁 ASSETS*/
import { ControlIcon, DashIcon, LogOutIcon, MaintenanceIcon, MapIcon, ReportIcon, AdmIcon, Config } from "../../Assets/icons/MenuIcons";

/* 🎨 STYLES */
import { Container, Gradient, MenuHeader, MenuContent, MenuFooter } from "./styles";

const SideBar = () => {
    const navigate = useNavigate();
    const user = useSelector(state => state.userReducer);
    const visibility = useSelector(state => state.MenuReducer.visibility);
    const equipamento = useSelector(state => state.generalReducer.Equipament);
    const currentPage = window.location.pathname;

    const { t } = useTranslation();

    let Dashboard= [];
    try {
        
        Dashboard.push(
            {
                text: t("dashboards.sub-items.general.sidebar-title"),
                page: equipamento ? `/dashboard/${equipamento}` : `/dashboard`,
                locationFunction : () => {
                    equipamento? navigate(`/dashboard/${equipamento}`) : navigate(`/dashboard`);
                }
            }
        )
        if(user?.user?.can?.includes('loss_control.sanep')){
            Dashboard.push(
                {
                    text: t("dashboards.sub-items.loss-control.sidebar-title"),
                    page: '/dashboard/perdas',
                    locationFunction : () => {
                        navigate('/dashboard/perdas');
                    }
                }
            )
        }    
    } catch (error) {
        
    }

    let Administrativo = []
    // Adiciona os itens conforme as permissões
    // necessário alterar no menu mobile
    try {
        if(user?.user?.can?.includes('allocation.index')){
            Administrativo.push(
                {
                    text: t("administrative.sub-items.allocations.sidebar-title"),
                    page: '/adm/alocacoes',
                    locationFunction : () => {
                        navigate('/adm/alocacoes');
                    }
                }
            )
        }
        if(user?.user?.can?.includes('role.index')){
            Administrativo.push(
                {
                    text: t("administrative.sub-items.positions.sidebar-title"),
                    page: '/adm/cargos',
                    locationFunction : () => {
                        navigate('/adm/cargos');
                    }
                }
            )
        }
        if(user?.user?.can?.includes('equipment.index')){
            Administrativo.push(
                {
                    text: t("administrative.sub-items.equipments.sidebar-title"),
                    page: '/adm/equipamentos',
                    locationFunction : () => {
                        navigate('/adm/equipamentos');
                    }
                }
            )
        }
        if(user?.user?.can?.includes('user.index')){
            Administrativo.push(
                {
                    text: t("administrative.sub-items.employees.sidebar-title"),
                    page: '/adm/funcionarios',
                    locationFunction : () => {
                        navigate('/adm/funcionarios');
                    }
                }
            )
        }
        if(user?.user?.can?.includes('group.index')){
            Administrativo.push(
                {
                    text: t("administrative.sub-items.groups.sidebar-title"),
                    page: '/adm/grupos',
                    locationFunction : () => {
                        navigate('/adm/grupos');
                    }
                }
            )
        }
        if(user?.user?.can?.includes('permission.index')){
            Administrativo.push(
                {
                    text: t("administrative.sub-items.permissions.sidebar-title"),
                    page: '/adm/permissoes',
                    locationFunction : () => {
                        navigate('/adm/permissoes');
                    }
                }
            )
        }
        if(user?.user?.can?.includes('log.index')){
            Administrativo.push(
                {
                    text: t("administrative.sub-items.logs.sidebar-title"),
                    page: '/adm/logs',
                    locationFunction : () => {
                        navigate('/adm/logs')
                    }
                }
            )
        }        
    } catch (error) {
        
    }

    let Reports = [];
    try {
        Reports.push(
            {
                text: t("reports.sub-items.history.sidebar-title"),
                page: '/historico/'+equipamento,
                locationFunction : () => {
                    navigate(`/historico/${equipamento}`);
                }
            }
        )
        Reports.push(
            {
                text: t("reports.sub-items.charts.sidebar-title"),
                page: '/historico/graphs',
                locationFunction : () => {
                    navigate(`/historico/graphs`);
                }
            }
        )
    } catch (error) {
        
    }

    let Maintenances = []
    // try {
    //     if(user?.user?.can?.includes('maintenance.view')){
    //         Maintenances.push(
    //             {
    //                 text: t("maintenance.sub-items.list.sidebar-title"),
    //                 page: '/manutencoes',
    //                 locationFunction : () => {
    //                     navigate(`/manutencoes`);
    //                 }
    //             }
    //         )
    //         Maintenances.push(
    //             {
    //                 text: t("maintenance.sub-items.reports.sidebar-title"),
    //                 page: '/manutencoes/report',
    //                 locationFunction : () => {
    //                     navigate(`/manutencoes/report`);
    //                 }
    //             }
    //         )

    //     }
    // } catch (error) {
        
    // }

    const ADMIN_USERS = [
        "7d3ad31c-572c-4be2-811f-9b4f14a9564f",
        "182fbfd6-86ab-4fa2-b588-c12825c64361",
        "2123e214-6dde-4dc0-9911-41b17ff4b067",
        "310a93b7-a4d7-47c9-ad75-0ae389d7ff2d",
        "52984c5a-b903-4577-8131-a48981dc8ffb"
    ];

    let ConfigRoutes = [];

    if (ADMIN_USERS.includes(user?.user?.id)) {
        ConfigRoutes.push({
            text: "Commands",
            page: "/PartCommands",
            locationFunction: () => {
            navigate("/PartCommands");
            }
        });
        ConfigRoutes.push({
            text: "CommandsVariables",
            page: "/PartCommandsVariables",
            locationFunction: () => {
            navigate("/PartCommandsVariables");
            }
        });
        ConfigRoutes.push({
            text: "CommandsHasVariables",
            page: "/PartCommandsHasVariables",
            locationFunction: () => {
            navigate("/PartCommandsHasVariables");
            }
        });
        ConfigRoutes.push({
            text: "CommandsVariablesAlarms",
            page: "/PartCommandsVariablesAlarms",
            locationFunction: () => {
            navigate("/PartCommandsVariablesAlarms");
            }
        });
        ConfigRoutes.push({
            text: "EquipmentHasCommands",
            page: "/EquipmentHasPartsCommands",
            locationFunction: () => {
            navigate("/EquipmentHasPartsCommands");
            }
        });
        ConfigRoutes.push({
            text: "EncapsuledVariablesGroups",
            page: "/EncapsuledVariablesGroups",
            locationFunction: () => {
            navigate("/EncapsuledVariablesGroups");
            }
        });
        ConfigRoutes.push({
            text: "CommandsVariablesAcceptUnits",
            page: "/PartCommandsVariablesAcceptUnits",
            locationFunction: () => {
            navigate("/PartCommandsVariablesAcceptUnits");
            }
        });
        ConfigRoutes.push({
            text: "CommandsVariablesAcceptValues",
            page: "/PartCommandsVariablesAcceptValues",
            locationFunction: () => {
            navigate("/PartCommandsVariablesAcceptValues");
            }
        });
    }

    return(
        <Container 
            onMouseEnter={() => {
                store.dispatch(ChangeTextVisibility(true));
            }}
            onMouseLeave={() => {
                store.dispatch(ChangeTextVisibility(false));
            }}
            >
            <Gradient>
                <MenuHeader>
                    <ImageProfile Image={user.user.foto} username={user.user.nome} function={() => navigate("/perfil")} page={"/perfil"}></ImageProfile>
                </MenuHeader>

                <MenuContent>
                    <SideBarItem Icon={MapIcon} select={currentPage === '/'} Text={t("map.sidebar-title")} visibility={visibility} function={() => navigate("/")} page = {'/'}/>

                    {/* <SideBarItem Icon={DashIcon} select={currentPage.includes('/dashboard')} Text={t("dashboards.sidebar-title")} visibility={visibility}
                        function={() => equipamento? navigate(`/dashboard/${equipamento}`) : navigate(`/dashboard`)}
                        page = {equipamento ? `/dashboard/${equipamento}` : `/dashboard`}/> */}

                    <SideBarItem Icon={DashIcon} Text={t("dashboards.sidebar-title")}  visibility={visibility} select={currentPage.includes('/dashboard')}>
                        {Dashboard.length > 0 && <SideBarSubItem itens={Dashboard}/>}
                    </SideBarItem>
                   
                    <SideBarItem Icon={ControlIcon} select={currentPage.includes('/controle')} Text={t("control.sidebar-title")}  visibility={visibility}
                        function={() => equipamento? navigate(`/controle/${equipamento}`) : navigate(`/controle`)}
                        page = {equipamento ? `/controle/${equipamento}` : `/controle`}/>
                    
                    <SideBarItem Icon={ReportIcon} Text={t("reports.sidebar-title")} visibility={visibility} select={currentPage.includes('/historico')}>
                        {Reports.length > 0 && <SideBarSubItem itens={Reports}/>}
                    </SideBarItem>

                    <SideBarItem Icon={MaintenanceIcon} Text={t("maintenance.sidebar-title")} visibility={visibility} select={currentPage.includes('/manutencoes')}>
                        {Maintenances.length > 0 && <SideBarSubItem itens={Maintenances}/>}
                    </SideBarItem>

                    <SideBarItem Icon={AdmIcon}  select={currentPage.includes('/funcionarios') || currentPage.includes('/equipamentos')
                    || currentPage.includes('/alocacoes') || currentPage.includes('/grupos') || currentPage.includes('/logs')} Text={t("administrative.sidebar-title")} visibility={visibility}>
                            {Administrativo.length > 0 && <SideBarSubItem itens={Administrativo}/>}
                    </SideBarItem>

                    {ADMIN_USERS.includes(user?.user?.id) &&
                        <SideBarItem Icon={Config} Text={t("config-routes.sidebar-title")} visibility={visibility} select={currentPage.includes('/config-routes')}>
                            {ConfigRoutes.length > 0 && <SideBarSubItem itens={ConfigRoutes}/>}
                        </SideBarItem>
                    }

                </MenuContent>

                <MenuFooter>
                    <SideBarLogout Icon={LogOutIcon} />
                </MenuFooter>
            </Gradient>
        </Container>
    )
}

export default SideBar;